import CryptoJS from 'crypto-js';

const desHelper = {
    k:"enkidictnet.cn|enkidictnet.cn|!@",
    encode:function(str){
        const keyUtf8 = CryptoJS.enc.Utf8.parse(this.k);
        const encrypted = CryptoJS.AES.encrypt(str, keyUtf8, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });
        // 返回 Base64 字符串，与 .NET 兼容
        return encrypted.toString();
    },
    decode:function(str){
        const keyUtf8 = CryptoJS.enc.Utf8.parse(this.k);
        const decrypted = CryptoJS.AES.decrypt(str, keyUtf8, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });
        // 转成 UTF8 字符串
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}

export default desHelper;